"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setMarkerCategory = exports.setMarkerInfo = exports.applyLengthLimit = void 0;
const checkUserAgent_1 = require("../utils/checkUserAgent");
const replaceAll_1 = require("./replaceAll");
const applyLengthLimit = (name, length) => {
    if (name && length) {
        if (name.length <= length) {
            return name;
        }
        if ((0, checkUserAgent_1.checkDevice)() === "mobile") {
            return name.substring(0, length - 2) + "...";
        }
        else {
            return name.substring(0, length) + "...";
        }
    }
    return "";
};
exports.applyLengthLimit = applyLengthLimit;
const setMarkerInfo = (name, branch, area) => {
    let result = name;
    if (!name) {
        return "";
    }
    if (name) {
        if (branch) {
            result = name + " " + branch;
        }
        else {
            if (area && Array.isArray(area)) {
                result = name + " " + area[0];
            }
        }
    }
    return result;
};
exports.setMarkerInfo = setMarkerInfo;
const setMarkerCategory = (category) => {
    let result = [];
    if (!category) {
        return "";
    }
    result = (0, replaceAll_1.replaceAll)((0, replaceAll_1.replaceAll)(category, "<em>", ""), "</em>", "").split(", ");
    return result.length === 1 ? result[0] : result[0] + ", " + result[1];
};
exports.setMarkerCategory = setMarkerCategory;
